

jQuery(document).ready(function(jQuery) {
  // jQuery('.ourStoryScroller').slick({
  //   infinite: true,
  //   slidesToShow: 5,
  //   slidesToScroll: 1,
  //   infinite: true,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   arrows: false,
  //   variableWidth: true
  // });

  jQuery('.ourStoryScroller').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    variableWidth: true,
    // cssEase: 'linear', 
    responsive: [
        {
            breakpoint: 768, // 767px and below
            settings: {
               speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable:false,
    focusOnSelect:false,
    pauseOnFocus:false,
    pauseOnHover:false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
            }
        }
    ]
});



jQuery('.eventSlider').owlCarousel({
    items:1,
    smartSpeed:450,
    nav: true,
    responsive:{
      0:{
          nav:false
      },
      768:{
          nav:true
      }
  }
});


/*
  jQuery('#videoPlayAction').click(function() {
      this.paused ? this.play() : this.pause();
  });
*/
  
});

jQuery('.chiDogSlider .owl-carousel').owlCarousel({
  center: true,
  loop: true,
  nav: true,
  items: 5,
  navText: ['<i class="fas fa-chevron-left"></i>','<i class="fas fa-chevron-right"></i>'],
  responsive:{
    0:{
      items: 2,
    },
    768:{
      items: 3,
    },
    990:{
      items: 5,
    }
  },
  onInitialized: coverFlowEfx,
  onTranslate: coverFlowEfx,
});

function coverFlowEfx(e){
  if (jQuery('.chiDogSlider .owl-dots')) {
    jQuery('.chiDogSlider .owl-dots').remove();
  }
  idx = e.item.index;
  jQuery('.chiDogSlider .owl-item.big').removeClass('big');
  jQuery('.chiDogSlider .owl-item.medium').removeClass('medium');
  jQuery('.chiDogSlider .owl-item.mdright').removeClass('mdright');
  jQuery('.chiDogSlider .owl-item.mdleft').removeClass('mdleft');
  jQuery('.chiDogSlider .owl-item.smallRight').removeClass('smallRight');
  jQuery('.chiDogSlider .owl-item.smallLeft').removeClass('smallLeft');
  jQuery('.chiDogSlider .owl-item').eq(idx -1).addClass('medium mdleft');
  jQuery('.chiDogSlider .owl-item').eq(idx).addClass('big');
  jQuery('.chiDogSlider .owl-item').eq(idx + 1).addClass('medium mdright');
  jQuery('.chiDogSlider .owl-item').eq(idx + 2).addClass('smallRight');
  jQuery('.chiDogSlider .owl-item').eq(idx - 2).addClass('smallLeft');
}

var click = false;

jQuery('#play-carousel').click(function(evt) {
  click = !click;
  if(click){
    jQuery('.status').html('Autoplay: ON');
    jQuery('.owl-carousel').trigger('play.owl.autoplay', [1000, 1000]);
    jQuery(this).html("Stop");
  } else {
    jQuery('.owl-carousel').trigger('stop.owl.autoplay');
    jQuery(this).html("Play");
    jQuery('.status').html('Autoplay: OFF');
  }

});